import { Component, Prop, Watch } from "vue-property-decorator";
import InputDefaultForm from "../../default/InputDefaultForm";
import { InputOption, KeyValue } from "../../../../models/Input";

@Component
export default class SelectForm extends InputDefaultForm {
	@Prop()
	public dataInputOption!: InputOption;

	@Prop()
	public listOption!: KeyValue[];

	@Prop()
	public maxHeight!: number;

	public isAppear = false;

	public refreshEvent = false;

	public reverse = false;

	public mounted(): void {
		this.$forceUpdate();
	}

	@Watch("dataInputOption.trigger")
	public checkValidation(): void {
		this.checkValidationDefault();
		this.$forceUpdate();
	}

	public clickOutside(): void {
		this.close();
	}

	private close(): void {
		this.isAppear = false;
		this.isFocused = false;
		this.refreshEvent = !this.refreshEvent;
	}

	public click(event: any, item: KeyValue): void {
		if (item === undefined) {
			this.dataInputOption.vmodel = "";
			this.dataInputOption.display = "";
			this.success = false;
		} else {
			this.dataInputOption.vmodel = item.key;
			this.dataInputOption.display = item.value;
			this.$emit("changed");
		}

		this.dataInputOption.message = "";
		this.dataInputOption.error = false;
		this.close();
	}

	@Watch("isFocused")
	public switchMenu(): void {
		if (this.isFocused) {
			this.isAppear = true;

			this.setDirection();
		}

		this.$emit("isFocused", this.isFocused);
	}

	@Watch("isAppear")
	private watchIsAppear(): void {
		setTimeout(() => {
			this.refreshEvent = !this.refreshEvent;
		}, (this.isAppear) ? 0 : 200);
	}

	public keydown(e: any): void {
		if (e.code === "Tab") {
			this.isAppear = false;
		}
	}

	@Watch("dataInputOption.vmodel")
	public watchSelectVmodel(): void {
		if (this.listOption !== undefined && this.listOption.length > 0) {
			const result = this.listOption.filter(item => item.key === this.dataInputOption.vmodel).map(item => item.value)[0];

			if (result != undefined) {
				this.dataInputOption.display = result;
			} else if (this.dataInputOption.disabled) {
				this.dataInputOption.display = this.dataInputOption.vmodel;
			} else {
				this.dataInputOption.vmodel = "";
				this.dataInputOption.display = "";
			}
		} else {
			this.dataInputOption.display = this.dataInputOption.vmodel;
		}

		this.$forceUpdate();
	}

	private setDirection(): void {
		const input = <HTMLDivElement> this.$refs.input;
		const topSpace = input.getBoundingClientRect().top;
		const bottomSpace = document.body.clientHeight - input.getBoundingClientRect().bottom;

		this.reverse = (topSpace > bottomSpace);
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/extended/SelectForm/SelectForm.ts